import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#E4E7F5] bg-[#EEF0FA] mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-[#1E3A8A] flex items-center justify-center text-[#F8F9FE] font-display font-bold text-sm">
              KSB
            </div>
            <span className="font-display font-bold text-lg">Keritex Staffing Bureau</span>
          </div>
          <p className="text-sm text-[#5B6478] mt-3 leading-relaxed">
            Connecting Kenyan households and businesses with vetted, professional staff.
          </p>
          <p className="text-xs text-[#5B6478] mt-2">keritexstaffing.co.ke</p>
        </div>
        <div>
          <div className="label-eyebrow mb-3">Platform</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/browse" className="hover:text-[#1E3A8A]">Browse Staff</Link></li>
            <li><Link to="/pricing" className="hover:text-[#1E3A8A]">Pricing</Link></li>
            <li><Link to="/signup" className="hover:text-[#1E3A8A]">Become staff</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><span className="text-[#5B6478]">About</span></li>
            <li><span className="text-[#5B6478]">Careers</span></li>
            <li><span className="text-[#5B6478]">Contact</span></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-3">Coverage</div>
          <ul className="space-y-2 text-sm text-[#5B6478]">
            <li>Nairobi · Mombasa · Kisumu</li>
            <li>Eldoret · Nakuru</li>
            <li>Expanding across East Africa</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E4E7F5]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#5B6478]">
          <div>© 2026 Keritex Staffing Bureau. All rights reserved.</div>
          <div>Made in Kenya. Currency: KES.</div>
        </div>
      </div>
    </footer>
  );
}
